import {
    ITEM_BORDER_MULTIPLIER,
    THEME_BASE_BORDER_RADIUS,
} from "./defaultThemeParams"
import { FILTER_TAB_COLLAPSE_MS } from "../constants/generalConstants"

/**
 * Use the fullscreen element if in fullscreen mode, otherwise just the document's body
 * @returns {Element | nul} The container element
 */
export function container(): Element | null {
    return document.fullscreenElement ?? document.body
}

// Reused in date picker
export const TEXT_FIELD_DEFAULT_PROPS = {
    fullWidth: true,
    InputLabelProps: {
        shrink: true,
        sx: { px: 3 },
    },
    InputProps: {
        sx: { borderRadius: ITEM_BORDER_MULTIPLIER },
    },
    sx: {
        mt: 2,
        "& .MuiOutlinedInput-notchedOutline": {
            px: 3,
        },
    },
}

// Base config to be applied to all themes
export const BASE_THEME_CONFIG = {
    typography: {
        fontFamily: "Roboto",
        h2: {
            fontSize: "3.75rem",
            fontWeight: 400,
        },
        h3: {
            fontSize: "2.7rem",
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: THEME_BASE_BORDER_RADIUS,
    },
    components: {
        // Textfield default props
        MuiTextField: {
            defaultProps: TEXT_FIELD_DEFAULT_PROPS,
        },
        MuiSkeleton: {
            defaultProps: {
                variant: "rectangular" as
                    | "circular"
                    | "rectangular"
                    | "rounded"
                    | "text",
            },
        },
        MuiButton: {
            defaultProps: {
                size: "large" as const,
            },
        },
        MuiMenu: {
            defaultProps: {
                container,
            },
        },
        MuiTooltip: {
            defaultProps: {
                PopperProps: {
                    container,
                },
            },
        },
        MuiModal: {
            defaultProps: {
                container,
            },
        },
        MuiCollapse: {
            defaultProps: {
                mountOnEnter: true,
                unmountOnExit: true,
                timeout: FILTER_TAB_COLLAPSE_MS,
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 950,
            lg: 1200,
            xl: 1536,
        },
    },
}
